import { AudioStatus } from "../../constants";

const AudioActions = {
    ACTIVE: 1,
    INACTIVE: 0
};

export const getStatus = (status) =>
    status === AudioStatus.ACTIVE ? AudioStatus.INACTIVE : AudioStatus.ACTIVE;

export const getStatusRunningOrCanceled = (status) =>
    status === AudioStatus.ACTIVE ? AudioStatus.ACTIVE : AudioStatus.INACTIVE;

export const findStatusChecked = (status, name) => {
    return status === AudioStatus.ACTIVE ? AudioActions.ACTIVE : AudioActions.INACTIVE;
};

export const handleAdModal = (setState, state) => setState(!state);
